import script from "./AccountRebateRelation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountRebateRelation.vue?vue&type=script&setup=true&lang=ts"

import "./AccountRebateRelation.vue?vue&type=style&index=0&id=46f1e6d2&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f1e6d2"]])

export default __exports__